import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  [
    'path',
    {
      d: 'M11 22c-3.806-1.45-7-3.966-7-9V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v4',
      key: 'hf1sz5',
    },
  ],
  ['path', { d: 'M14.923 16.547 14 16.164', key: '41f878' }],
  ['path', { d: 'm14.923 18.843-.923.383', key: '82rvv5' }],
  ['path', { d: 'M16.547 14.923 16.164 14', key: '1r7ypn' }],
  ['path', { d: 'm16.547 20.467-.383.924', key: 'au4kyj' }],
  ['path', { d: 'm18.843 14.923.383-.923', key: '1cbrwq' }],
  ['path', { d: 'm19.225 21.391-.382-.924', key: '1u2bh9' }],
  ['path', { d: 'm20.467 16.547.923-.383', key: 'cprboc' }],
  ['path', { d: 'm20.467 18.843.923.383', key: 'inm8l2' }],
  ['circle', { cx: '17.695', cy: '17.695', r: '3', key: '1i1rmh' }],
];

/**
 * @component @name ShieldCogCorner
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMjJjLTMuODA2LTEuNDUtNy0zLjk2Ni03LTlWNmExIDEgMCAwIDEgMS0xYzIgMCA0LjUtMS4yIDYuMjQtMi43MmExLjE3IDEuMTcgMCAwIDEgMS41MiAwQzE0LjUxIDMuODEgMTcgNSAxOSA1YTEgMSAwIDAgMSAxIDF2NCIgLz4KICA8cGF0aCBkPSJNMTQuOTIzIDE2LjU0NyAxNCAxNi4xNjQiIC8+CiAgPHBhdGggZD0ibTE0LjkyMyAxOC44NDMtLjkyMy4zODMiIC8+CiAgPHBhdGggZD0iTTE2LjU0NyAxNC45MjMgMTYuMTY0IDE0IiAvPgogIDxwYXRoIGQ9Im0xNi41NDcgMjAuNDY3LS4zODMuOTI0IiAvPgogIDxwYXRoIGQ9Im0xOC44NDMgMTQuOTIzLjM4My0uOTIzIiAvPgogIDxwYXRoIGQ9Im0xOS4yMjUgMjEuMzkxLS4zODItLjkyNCIgLz4KICA8cGF0aCBkPSJtMjAuNDY3IDE2LjU0Ny45MjMtLjM4MyIgLz4KICA8cGF0aCBkPSJtMjAuNDY3IDE4Ljg0My45MjMuMzgzIiAvPgogIDxjaXJjbGUgY3g9IjE3LjY5NSIgY3k9IjE3LjY5NSIgcj0iMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/shield-cog-corner
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const ShieldCogCorner = createLucideIcon('shield-cog-corner', __iconNode);

export default ShieldCogCorner;
